//
// Copyright 2025 DXOS.org
//
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, svg } from 'lit';
import { customElement, property } from 'lit/decorators.js';
// Shared with @dxos/react-ui's IconRegistry; see IconRegistry.tsx for the bridge contract.
const REGISTRY_GLOBAL = '__dxIconRegistry';
const getRegistry = () => globalThis[REGISTRY_GLOBAL];
let DxIcon = class DxIcon extends LitElement {
    constructor() {
        super(...arguments);
        // TODO(thure): Get Hue type used in theme.
        this.size = 4;
        this.icon = 'ph--circle-dashed--regular';
    }
    #unsubscribe;
    disconnectedCallback() {
        super.disconnectedCallback();
        this.#unwatchRegistry();
    }
    render() {
        const registry = getRegistry();
        if (registry && !registry.hasIcon(this.icon)) {
            registry.requestIcon(this.icon);
            // Omit the <use> while unresolved, mirroring useIconHref: the subscription re-renders
            // once the symbol lands rather than leaving a transient broken ref in the DOM.
            this.#watchRegistry(registry);
            return svg `<svg class="dx-icon" data-size=${this.size}></svg>`;
        }
        this.#unwatchRegistry();
        const href = `#${this.icon}`;
        return svg `<svg class="dx-icon" data-size=${this.size}><use href=${href} /></svg>`;
    }
    createRenderRoot() {
        return this;
    }
    #watchRegistry(registry) {
        if (this.#unsubscribe) {
            return;
        }
        this.#unsubscribe = registry.subscribe(() => {
            if (registry.hasIcon(this.icon)) {
                this.requestUpdate();
            }
        });
    }
    #unwatchRegistry() {
        this.#unsubscribe?.();
        this.#unsubscribe = undefined;
    }
};
__decorate([
    property({ type: String })
], DxIcon.prototype, "size", void 0);
__decorate([
    property({ type: String })
], DxIcon.prototype, "icon", void 0);
DxIcon = __decorate([
    customElement('dx-icon')
], DxIcon);
export { DxIcon };
//# sourceMappingURL=dx-icon.js.map